import AirDatepicker from "air-datepicker";
import localeJa from "air-datepicker/locale/ja";
import dayjs from "dayjs";
import isLeapYear from "dayjs/plugin/isLeapYear"; // import plugin
import ja from "dayjs/locale/ja";
import minMax from "dayjs/plugin/minMax";
dayjs.extend(isLeapYear); // use plugin
dayjs.extend(minMax); // use plugin
dayjs.locale(ja); // use locale
dayjs().format();
export const controlSalesPeriod = () => {
  const today = dayjs();

  // ====================================================
  // 販売開始期間をチェックし、現在の日付が販売開始期間外であれば、targetProductにoutOfSalesPeriodクラスを追加する
  const salesStartDateElements = document.querySelectorAll(
    ".cartShippingOption__salesStartDateMetafield"
  );
  const salesEndDateElements = document.querySelectorAll(
    ".cartShippingOption__salesEndDateMetafield"
  );

  let startDateObjectArray = [];
  salesStartDateElements.forEach((el: HTMLElement, index) => {
    startDateObjectArray.push({
      productIndex: index + 1,
      salesStartDateKey: el.dataset.mfkey,
      salesStartDate:
        el.dataset.mfvalue && el.dataset.mfvalue !== ""
          ? dayjs(el.dataset.mfvalue)
          : null,
    });
  });
  console.log("startDateObjectArray", startDateObjectArray);

  const startEndDateObjectArray = startDateObjectArray.map((s, index) => {
    const targetSalesEndDate = Array.from(salesEndDateElements).find(
      (el: HTMLElement) => el.dataset.mfssdkey === s.salesStartDateKey
    ) as HTMLElement;
    return {
      ...s,
      salesEndDateKey: targetSalesEndDate.dataset.mfkey,
      salesEndDate:
        targetSalesEndDate.dataset.mfvalue &&
        targetSalesEndDate.dataset.mfvalue !== ""
          ? dayjs(targetSalesEndDate.dataset.mfvalue)
          : null,
    };
  });
  console.log("startEndDateObjectArray", startEndDateObjectArray);

  let cartCheckoutBtnFlg = false;

  startEndDateObjectArray.forEach((s) => {
    if (s.salesStartDate) {
      if (s.salesStartDate.isAfter(today)) {
        console.log("販売期間外の商品が含まれます。");
        console.log("s", s);

        cartCheckoutBtnFlg = true;

        const targetWarning = document.querySelector(
          `[data-salesStartDateKey="${s.salesStartDateKey}"]`
        );
        if (targetWarning) {
          targetWarning.classList.remove("hidden");
        }

        const cartShippingOption =
          document.querySelector(`#cartShippingOption`);
        if (cartShippingOption) {
          cartShippingOption.classList.add("hidden");
        }
      }
    }

    if (s.salesEndDate) {
      if (s.salesEndDate.isBefore(today)) {
        console.log("販売期間外の商品が含まれます。");
        console.log("s", s);

        cartCheckoutBtnFlg = true;

        const targetWarning = document.querySelector(
          `[data-salesEndDateKey="${s.salesEndDateKey}"]`
        );
        if (targetWarning) {
          targetWarning.classList.remove("hidden");
        }

        const cartShippingOption =
          document.querySelector(`#cartShippingOption`);
        if (cartShippingOption) {
          cartShippingOption.classList.add("hidden");
        }
      }
    }
  });
  if (cartCheckoutBtnFlg) {
    const cartCheckoutBtn = document.querySelector("#cartCheckoutBtn");
    const checkoutBtnError = document.querySelector(
      "#checkoutBtnError"
    ) as HTMLElement;
    const fakeCartCheckoutBtn = document.querySelector(
      "#fakeCartCheckoutBtn"
    ) as HTMLElement;
    const fakeCartCheckoutBtnText = document.querySelector(
      "#fakeCartCheckoutBtnText"
    ) as HTMLElement;

    // cartCheckoutBtnを削除して、販売期間外のメッセージを表示する
    if (cartCheckoutBtn) {
      cartCheckoutBtn.remove();
    }
    if (checkoutBtnError) {
      checkoutBtnError.classList.remove("hidden");
      checkoutBtnError.innerText = "販売期間外の商品が含まれています。";
    }
  }

  // TODO
  // 画面内のすべての販売期間外の商品を対象とした処理にする
};
